import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const CareerPagesHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Career Pages
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Create and customize your company's career page to showcase your organization
            and attract top talent. Build a compelling employer brand and highlight your
            company culture.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Page Customization
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Customize your career page with your company branding, colors, and content.
            Add your company logo, mission statement, and showcase your workplace culture.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Job Listings
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Display your open positions in an organized and attractive format. Categorize
            jobs by department, location, or job type for easy navigation.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Company Culture
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Highlight your company culture through photos, videos, and employee testimonials.
            Show potential candidates what it's like to work at your organization.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Mobile Optimization
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Ensure your career page looks great on all devices. Our responsive design
            automatically adapts to different screen sizes for optimal viewing.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/account/customize-careers-page"
              color="primary"
              variant="contained"
            >
              Customize Career Page
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default CareerPagesHelp; 